import PinyinUtil from "./PinyinUtil";
import { letterMatcher } from "./pinyin";
import { Platform, NativeModules } from "react-native";
import { getUid } from "../store/token";
import { UserSchema } from "../realm/contactSchema";
import { MessageSchema } from "../realm/schema";
import {
    AuditActionStatus,
    ChartMessageItem,
    MessageAuditStatus, MessageType,
} from "../constants/types";
import { Avatar, TopicWithSummary } from "../../imsdk/api/topic";
import { User } from "../../imsdk/db/t_user";
import { getUserName } from "../screen/Chat/chat-helper";
import {
    Str_BeforeYesterday, Str_ChatRecord, Str_File, Str_Friday, Str_GroupChat, Str_Img,
    Str_Monday, Str_RtcAudio, Str_RtcVideo, Str_Saturday, Str_SendFail, Str_SingleChat,
    Str_Sunday, Str_Thursday,
    Str_Tuesday, Str_Video, Str_Voice,
    Str_Wednesday,
    Str_Yesterday,
    Str_You
} from "../language/string_res";
import { Msg } from "../../imsdk/db/t_msg";
import { GroupSummary } from "../../imsdk/db/t_group_summary";
import { GroupMember } from "../../imsdk/db/t_group_member";
import { Group } from "../../imsdk/db/t_group";
import { upsetMsg } from "../store/ChatStore";
import { showToast } from "../components/Toast";
import { setLastSendMsg } from "../net/database";
import time from "../../imsdk/time";
import globalEventBus from "./EventBus";

export const isIOS = Platform.OS === "ios";

// 是否为群聊
export const isGroupTopic = (tid: string) => (tid && tid.charAt(0) === "g") === true;


export function orderListByLetter(list: GroupSummary[]) {
    let listData = [];
    const n = list && list.length > 0 ? list.length : 0;
    for (let i = 0; i < n; i++) {
        const obj = list[i];
        const name = obj.remark && obj.remark.length > 0 ? obj.remark : obj.name
        let pinyin = PinyinUtil.getFullChars(name).toUpperCase();
        let firstLetter = pinyin.substring(0, 1);
        if (firstLetter < "A" || firstLetter > "Z") {
            firstLetter = "#";
        }

        listData.push({
            pinyin: pinyin,
            firstLetter: firstLetter,
            sectionStart: false,
            ...JSON.parse(JSON.stringify(obj))
        });
    }

    // 按拼音排序
    listData.sort(function (a, b) {
        if (a.pinyin === undefined || b.pinyin === undefined) {
            return 1;
        }
        if (a.pinyin > b.pinyin) {
            return 1;
        }
        if (a.pinyin < b.pinyin) {
            return -1;
        }
        return 0;
    });

    // 根据首字母分区
    for (let i = 0; i < listData.length; i++) {
        let obj = listData[i];
        if (i === 0) {
            obj.sectionStart = true;
        } else {
            let preObj = listData[i - 1];
            obj.sectionStart = preObj.firstLetter !== obj.firstLetter;
        }
    }

    const result: any = [];
    let sectionData: any = {};
    for (let i = 0; i < listData.length; i++) {
        let obj = listData[i];
        if (obj.sectionStart) {
            sectionData = {
                title: obj.firstLetter,
                data: [obj]
            };
            result.push(sectionData);
        } else {
            sectionData.data.push(obj);
        }
    }

    return result;
}

export function userListByLetter(list: (User | GroupMember)[]) {
    let listData = [];
    const n = list && list.length > 0 ? list.length : 0;
    for (let i = 0; i < n; i++) {
        const obj = list[i];
        const objElement = getUserName(obj)
        let pinyin = PinyinUtil.getFullChars(objElement).toUpperCase();
        let firstLetter = pinyin.substring(0, 1);
        if (firstLetter < "A" || firstLetter > "Z") {
            firstLetter = "#";
        }
        listData.push({
            pinyin: pinyin,
            firstLetter: firstLetter,
            sectionStart: false,
            ...JSON.parse(JSON.stringify(obj))
        });
    }

    // 按拼音排序
    listData.sort(function (a, b) {
        if (a.pinyin === undefined || b.pinyin === undefined) {
            return 1;
        }
        if (a.pinyin > b.pinyin) {
            return 1;
        }
        if (a.pinyin < b.pinyin) {
            return -1;
        }
        return 0;
    });

    // 根据首字母分区
    for (let i = 0; i < listData.length; i++) {
        let obj = listData[i];
        if (i === 0) {
            obj.sectionStart = true;
        } else {
            let preObj = listData[i - 1];
            obj.sectionStart = preObj.firstLetter !== obj.firstLetter;
        }
    }

    const result: any = [];
    let sectionData: any = {};
    for (let i = 0; i < listData.length; i++) {
        let obj = listData[i];
        if (obj.sectionStart) {
            sectionData = {
                title: obj.firstLetter,
                data: [obj]
            };
            result.push(sectionData);
        } else {
            sectionData.data.push(obj);
        }
    }
    return result;
}

/**
 * 联系人列表搜索（发起会话、群内选人等对齐）：姓名、邮箱、备注、昵称、昵称拼音、手机号。
 */
export function contactListSearchMatches(
    v: Partial<User> & Partial<GroupMember>,
    searchVal: string,
): boolean {
    console.log("contactListSearchMatches", v, searchVal);
    const q = searchVal ?? "";
    if (!v) {
        return false;
    }
    if ((v.name ?? "").includes(q)) {
        return true;
    }
    if (v.email && v.email.length > 0 && v.email.includes(q)) {
        return true;
    }
    if (v.remark && v.remark.length > 0 && v.remark.includes(q)) {
        return true;
    }
    if (v.nick && v.nick.length > 0 && v.nick.includes(q)) {
        return true;
    }
    if (
        v.nickPY &&
        v.nickPY.length > 0 &&
        v.nickPY.toLowerCase().includes(q.toLowerCase())
    ) {
        return true;
    }
    return !!(v.telno && v.telno.length > 0 && v.telno.includes(q));
}


export function formatUserToSectionList(users: User[]) {
    const letterHashArr = new Array<{ title: string; data: User[] }>(26);
    const setLetterHashArr = (item: User, index: number) => {
        if (!letterHashArr[index]) {
            letterHashArr[index] = {
                title: letterMatcher[index],
                data: []
            };
        }

        letterHashArr[index].data.push(item);
    };

    users.forEach((user) => {
        const name = user.namePYS || user.namePY || user.name || ''
        const c = name.length > 0 ? name.charCodeAt(0) - 65 : 26;
        if (c >= 0 && c < 26) {
            setLetterHashArr(user, c);
        } else {
            setLetterHashArr(user, 26);
        }
    });

    return letterHashArr.filter(Boolean);
}

/**
 * 获取ios导航栏高度
 * @param cb
 */
export const getIosStatusBar = (cb: (height: number) => void) => {
    if (isIOS) {
        try {
            // 检查 StatusBarManager 是否存在且有 getHeight 方法
            if (NativeModules?.StatusBarManager?.getHeight) {
                NativeModules.StatusBarManager.getHeight((response: any) =>
                    cb(response.height)
                );
            } else if (NativeModules?.StatusBarManager?.HEIGHT !== undefined) {
                // Web 平台或 fallback：使用 HEIGHT 属性
                cb(NativeModules.StatusBarManager.HEIGHT || 0);
            } else {
                // 如果都不存在，返回 0
                cb(0);
            }
        } catch (e) {
            // 捕获任何错误，返回默认值 0
            console.warn('getIosStatusBar error:', e);
            cb(0);
        }
    } else {
        // 非 iOS 平台，直接返回 0
        cb(0);
    }
};


export function getAvatarByItem2(item: TopicWithSummary): Avatar {
    if (item.summary?.avatarList?.avatar) {
        if (!item.summary.avatarList.uid) {
            item.summary.avatarList.uid = item.topic?.uid || 0;
        }
        return item.summary.avatarList;
    }
    if (item.topic.type === "group") {
        return { name: item.topic.remark || item.topic.name || Str_GroupChat, uid: 0, avatar:item.group?.avatar  };
    }
    return { name: item.topic.remark || item.topic.name || Str_SingleChat, uid: item.topic.uid };
}
export function getAvatarByUser(user: User | UserSchema): Avatar {
    const name = getDisplayName(user)
    return { name: name || Str_SingleChat, uid: user.uid, avatar: user.avatar ?? "" };
}


/**
 * 获取消息内容
 */
export const getMsgContent = (type: MessageType, content: string): string => {
    if (type === MessageType.VOICE) {
        return `[${Str_Voice}]`;
    }
    if (type === MessageType.IMAGE) {
        return `[${Str_Img}]`;
    }
    if (type === MessageType.VIDEO) {
        return `[${Str_Video}]`;
    }
    if (type === MessageType.TALK) {
        return `[${Str_ChatRecord}]`;
    }
    if (type === MessageType.RTC_VIDEO) {
        return `[${Str_RtcVideo}]`;
    }
    if (type === MessageType.RTC_VOICE) {
        return `[${Str_RtcAudio}]`;
    }
    if (type === MessageType.DOCUMENT) {
        return `[${Str_File}]`;
    }
    return content;
};

/**
 * 获取单条记录的头像， 好友或群聊记录中增加一个frontType属性
 * @param item 单条会话记录 || 单条好友记录 || 单条群组记录
 * @returns
 */
export function getAvatarByItem(item: any) {
    let left: Avatar = { name: '', uid: 0 };
    if (!item) {
        return left
    }
    if (
        item.frontType === "single" ||
        (!item.frontType && !item.topUsers) ||
        item.topUsers.length === 0
    ) {
        // 新的会话--个人
        left = {
            avatar: item.avatar,
            uid: item.uid,
            name: item.remark || item.nick || item.email || item.telno || ""
        }

    } else if (item.frontType === "group") {
        //新的会话--群
        left = item.memberAvatars;
    }
    return left;
}

/**
 * 判断是否含有att某个用户
 */
export function hasAttUser(uid: number, msg?: Msg): boolean {
    if (!msg || !msg.atUids) {
        return false;
    }
    return msg.atUids.includes(uid);
}

export function hasLatestMsgAttUser(
    uid: number,
    topicSummary: TopicWithSummary
): boolean {
    const { topic, summary } = topicSummary
    if (
        !summary ||
        !summary.latest ||
        summary.unreadCnt === 0
    ) {
        return false;
    }

    return hasAttUser(uid, summary?.latest);
}

export function notAttMessage(msg: MessageSchema): boolean {
    return !msg.atUids || msg.atUids.length === 0 || msg.sender !== getUid();
}

export function isSelfSingle(msg: MessageSchema) {
    return msg.sender === getUid();
}

export function isOldAuditPassMessage(msg: MessageSchema) {
    return (
        msg.visible === MessageAuditStatus.INFO &&
        msg.auditRst === AuditActionStatus.PASS
    );
}

// 对比两个mid的大小
export function betterMid(a = "", b = "", hasEqual = true) {
    if (!a || !b) {
        return;
    }
    if (a.length === b.length) {
        return hasEqual ? a >= b : a > b;
    }

    return a.length > b.length;
}

export function checkLatestMid(msg: MessageSchema, latestMid = "") {
    return betterMid(msg.mid, latestMid, false);
}

/**获取用户展示的名 */
export function getDisplayName(user: UserSchema | User) {
    if (user?.uid === getUid()) {
        return Str_You;
        // return user?.nick || user?.name;
    } else {
        return getUserName(user);
    }
}

export function getGroupTag(sender?: number, group?: Group): number {
    if (!sender) { return 0 }
    if (sender === group?.uid) {
        return 1//群主
    } else if (group?.adminUids.includes(sender)) {
        return 2//管理员
    } else {
        return 0
    }
}


export function isImageType(contentType: string) {
    return contentType.startsWith("image/");
}

const dateFormattersPlus = [
    {
        // 当天
        range: 0,
        format(date: number) {
            const targetDate = new Date(date);
            return `${("0" + targetDate.getHours()).slice(-2)}:${(
                "0" + targetDate.getMinutes()
            ).slice(-2)}`;
        }
    },
    {
        // 昨天
        range: 24 * 60 * 60 * 1000,
        format(date: number) {
            const targetDate = new Date(date);
            return `${Str_Yesterday} ${("0" + targetDate.getHours()).slice(-2)}:${(
                "0" + targetDate.getMinutes()
            ).slice(-2)}`;
        }
    },
    {
        // 前天
        range: 48 * 60 * 60 * 1000,
        format(date: number) {
            const targetDate = new Date(date);
            return `${Str_BeforeYesterday} ${("0" + targetDate.getHours()).slice(-2)}:${(
                "0" + targetDate.getMinutes()
            ).slice(-2)}`;
        }
    },
    {
        // 一周内
        range: 7 * 24 * 60 * 60 * 1000,
        format(date: number) {
            const targetDate = new Date(date);
            const week = [
                Str_Sunday,
                Str_Monday,
                Str_Tuesday,
                Str_Wednesday,
                Str_Thursday,
                Str_Friday,
                Str_Saturday
            ];
            return `${week[targetDate.getDay()]} ${(
                "0" + targetDate.getHours()
            ).slice(-2)}:${("0" + targetDate.getMinutes()).slice(-2)}`;
        }
    },
    {
        range: Date.now(),
        format(date: number) {
            return new Date(date)
                .toISOString()
                .slice(0, 16)
                .replace(/t/gi, " ");
        }
    }
];
export const beforeDatePlus = (date: number = Date.now()): string => {
    const diffBeforeTime = new Date().setHours(0, 0, 0, 0) - date;
    for (let i = 0; i < dateFormattersPlus.length; i++) {
        if (diffBeforeTime < dateFormattersPlus[i].range) {
            return dateFormattersPlus[i].format(date);
        }
    }

    return date.toString();
};


export function getPlatByAppkey(appkey: string): string {
    if (appkey.length > 0) {
        return appkey.charAt(0);
    }
    return "";
}

export function isPAppkey(appkey: string): boolean {
    return appkey.length > 0 && appkey.charAt(0) === "P";
}

export function buildSignalTopicId(uid1: number, uid2: number): string {
    return uid1 < uid2 ? `s_${uid1}_${uid2}` : `s_${uid2}_${uid1}`;
}


export function sendFail(failMsg: ChartMessageItem, tid: string, errMsg?: string) {
    failMsg.send_statue = "1"
    upsetMsg(failMsg).then()
    showToast(errMsg || Str_SendFail)
    if (failMsg.tid === tid) {
        globalEventBus.emit('SEND_MSG', failMsg)
    }
}

export async function sendSuc(msg: ChartMessageItem) {
    if (isGroupTopic(msg.tid)) {
        await setLastSendMsg({
            uid: msg.uid || 0,
            tid: msg.tid,
            time: time.now().getTime()
        });
    }
}

